import {inject} from "@angular/core";
import {filter, map} from "rxjs/operators";
import {CanActivateFn, Router} from '@angular/router';
import {AppStateService} from "@app/shared/services/app-state.service";

export const partnerPremiumGuard: CanActivateFn = () => {
  const router = inject(Router);
  const appStateService = inject(AppStateService);

  const emails = appStateService.partnerPremiumEmails;

  return appStateService.user$
    .pipe(
      filter((user) => user !== null),
      map((user) => {
          if (emails.includes(user.email || '')) {
            return true;
          } else {
            router.navigate([appStateService.getLngRout('home')]);
            return false;
          }
        }
      )
    );
};


